export default __webpack_public_path__ + "static/media/cm-central.cd8616a3.png";